"use strict";
// @ts-ignore
try {
    self['workbox:streams:6.5.2'] && _();
}
catch (e) { }
